const FFL_TIPS = [
    "Add store hours and services to boost visibility.",
    "Upload photos to showcase your store or inventory.",
    "Fill out your dealer description for better SEO.",
    "Add customer testimonials to build trust.",
    "Include your social media links to drive traffic.",
    "Use a clear subdomain name for easy sharing.",
    "Keep your dealer logo clean, legible, and on-brand.",
    "Choose a theme that matches your audience — tactical, modern, or classic.",
    "Make sure your contact info is accurate and up to date.",
    "Offer a brief but compelling specialty description to stand out.",
    "Enable fingerprinting or NFA support if you offer it — it drives niche traffic.",
    "Respond quickly to inquiries — fast replies earn more conversions.",
    "Showcase any certifications or training (e.g., gunsmithing, instructor).",
    "Use strong calls-to-action in your About section — tell people what to do next.",
    "If you’re a home-based FFL, emphasize appointment-based availability.",
    "Post real store/gallery photos — it builds instant legitimacy.",
    "List your transfer fees clearly — people compare that first.",
    "Add a policy section to answer common questions and cut back on messages.",
    "Select all specialties that apply — the more relevant you are, the more leads.",
    "Keep your site updated — stale info makes you look closed or unprofessional."
];

export default FFL_TIPS;